import { render, staticRenderFns } from "./taskRelationSetting.vue?vue&type=template&id=613fad50&scoped=true&"
import script from "./taskRelationSetting.vue?vue&type=script&lang=js&"
export * from "./taskRelationSetting.vue?vue&type=script&lang=js&"
import style0 from "./taskRelationSetting.vue?vue&type=style&index=0&id=613fad50&lang=scss&scoped=true&"
import style1 from "./taskRelationSetting.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613fad50",
  null
  
)

export default component.exports